__turbopack_context__.v({
  "calculatorInputContainer": "SliderRow-module-scss-module__s5Q0Ia__calculatorInputContainer",
  "itemContainer": "SliderRow-module-scss-module__s5Q0Ia__itemContainer",
  "slider": "SliderRow-module-scss-module__s5Q0Ia__slider",
  "sliderBox": "SliderRow-module-scss-module__s5Q0Ia__sliderBox",
  "sliderText": "SliderRow-module-scss-module__s5Q0Ia__sliderText",
});
